import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditItemModal, setShowEditItemTaxModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditItemModal, selectShowEditItemTaxModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_ITEM_FORM_TEMPLATE from './edit-item.template';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditItem = ({
    showEditItem,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditItemModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_ITEM")
        setModalTemplate(EDIT_ITEM_FORM_TEMPLATE);
    }, []);
    const endpoint = '/items';
    const endpointUrl = `${endpoint}/${editUUID}`;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditItem);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-item-group">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditItem}
                        setShowModal={setShowEditItemModal}
                        endpointUrl={endpointUrl}
                        size={"Large"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditItem: selectShowEditItemModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditItemModal: () =>
        disptach(setShowEditItemModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditItem);